var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('footer',{staticClass:"footer"},[_vm._v("\n    Made with "),_c('b-icon',{staticClass:"love",attrs:{"icon":"heart-multiple"}}),_vm._v(" by\n    "),_c('span',{staticClass:"has-text-success"},[_vm._v("MA")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }